<rx-intuitive-patient-header />

<div class="page-container">
	<rx-intuitive-order-layout *ngIf="(isActive$ | async) === false">
		<rx-procedure-button
			slot="procedure-button"
			[selectedProcedure]="selectedProcedure$ | async"
			[readOnly]="true"
			[canExpand]="false"
			[disabled]="true"
		/>

		<rx-favorite-selector
			class="send-to"
			slot="send-to"
			tlkCardContent
			[label]="'OrderSection.SendTo' | translate"
			[formControl]="sendToControl"
			[options]="sendToOptions$ | async"
			[isReadOnly]="true"
			[isDisabled]="true"
			[enableSimpleMode]="true"
		/>
	</rx-intuitive-order-layout>

	<rx-banner-dismissible
		*ngIf="isError$ | async"
		class="error-banner"
		type="error"
	>
		<span>{{ 'LabBroker.ErrorBannerMessage' | translate }}</span>
		<button
			tlkButton
			variant="ghost"
			size="m"
			data-testid="lab-broker-return-to-summary-button"
			(click)="onReturnToSummary()"
		>
			{{ 'LabBroker.ReturnToSummaryButton' | translate }}
		</button>
	</rx-banner-dismissible>

	<rx-lab-broker-iframe
		[iframeUrl]="iframeUrl$ | async"
		[isLoading$]="isLoading$"
	/>

	<rx-lab-broker-footer
		*ngIf="isFooterVisible$ | async"
		[integratorName]="integratorName$ | async"
		[isSaveAndContinueLaterVisible]="(isSaveAndContinueLaterButtonVisible$ | async) ?? false"
		[isSendToLabVisible]="(isCompleted$ | async) ?? false"
		(sendClicked)="onSendToLabClicked()"
		(saveAndContinueLaterClicked)="onSaveAndContinueLater()"
	/>
</div>